<template lang="html">
  <div class="space" :class="active">
    <el-badge  v-if="type !== 'add'&& itemNum > 0" :value="itemNum" class="item">
    </el-badge>
    <div class="img" v-if="type !== 'add'" @click="toSpace">
      <img v-if="imgUrl !==''" :src="imgUrl" alt="">
      <img v-if="imgUrl===''" src="../../assets/images/project.png" alt="">
    </div>
    <div class="img" v-if="type === 'add'" style="background-color:#757575">
      <i class="material-icons icon-add">add</i>
    </div>
    <div class="word" v-if="type !== 'add'" @click="toSpace">
      <span class="name">{{name}}</span>
      <span class="more" v-if="type === 'creat'">
        {{members}}{{message.Sl163}}
      </span>
      <span class="more" v-if="type === 'join'">
        {{message.Sl162.l0}} {{creater.name}} {{message.Sl162.l1}}
      </span>
    </div>
    <div class="word" v-if="type === 'add'">
      <span class="name" :title="message.Sl231">
        {{message.Sl231}}
      </span>
      <!-- <span class="more" v-if="creater === 0" :title="message.Sl164">
        {{message.Sl164}}
      </span> -->
      <span class="more">
        <i class="material-icons people">people_outline</i>
      </span>
    </div>
    <el-popover
      ref="popover"
      placement="bottom"
      width="180"
      v-model='tabShow'
      trigger="click"
      @show='showTab'
      @hide="active=''"
    >
    <div class="info-cell role" v-if="type === 'join'">
      <span>{{message.Sl165}}</span>
      <span style="float:right;font-weight:600;">{{role.name}}</span>
    </div>
    <div class="info-cell" @click="show(0)">{{message.Sl124}}</div>
    <div class="info-cell" @click="show(1)">{{message.Sl140}}</div>
    <div class="info-cell" @click="show(2)" v-if="type === 'creat'||role.type ===1">{{message.Sl166}}</div>
    <div class="info-cell" @click="show(3)" v-if="type === 'creat'||role.type ===1">{{message.Sl191}}</div>
    <!-- <div class="info-cell flow" v-if="type === 'join'">
      <span>{{message.Sl167}}</span>
      <span style="float:right;font-weight:600;margin:4px 4px 0 0;font-size:18px">{{flow}}</span>
    </div> -->
    </el-popover>
    <i v-popover:popover class="material-icons operation" v-if="type !== 'add'">more_vert</i>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      notice: 'notice',
      space: 'space'
    })
  },
  watch: {
    'notice.newPkg': function (val) {
      if (val) {
        if (this.id === localStorage.getItem('projectId')) {
          return
        }
        var x = this.itemNum
        for (var i = 0; i < val.length; i++) {
          if (val[i] === this.id) {
            x = x + 1
          }
        }
        this.itemNum = x
      }
    },
    space: function (val) {
      if (this.id === val.id) {
        this.active = 'active'
      } else {
        this.active = ''
      }
    }
  },
  props: {
    name: String,
    id: String,
    type: String,
    members: Number,
    imgUrl: String,
    creater: Object,
  },
  data () {
    return {
      itemNum: 0,
      role: '',
      active: '',
      flow: '',
      tabShow: false,
      message: {
        Sl231: this.$lang.ui.system.l231,
        Sl162: this.$lang.ui.system.l162,
        Sl163: this.$lang.ui.system.l163,
        Sl164: this.$lang.ui.system.l164,
        Sl165: this.$lang.ui.system.l165,
        Sl124: this.$lang.ui.system.l124,
        Sl140: this.$lang.ui.system.l140,
        Sl166: this.$lang.ui.system.l166,
        Sl167: this.$lang.ui.system.l167,
        Sl191: this.$lang.ui.system.l191
      }
    }
  },
  methods: {
    toSpace () {
      if (this.type === 'add') {
        return
      }
      this.itemNum = 0
      var data = this.notice.newPkg
      for (var i = 0; i < this.notice.newPkg.length; i++) {
        if (this.notice.newPkg[i] === this.id) {
          data.splice(i, 1)
        }
      }
      this.$store.dispatch('newPkg', data)
      this.$emit('toSpace')
    },
    showTab () {
      this.active = 'active'
      this.$api.getUserRole(this.id, response => {
        // console.log(response)
        if (response.permission.role === 0) {
          this.role = {
            type: 0,
            name: this.$lang.ui.system.l138
          }
        }
        if (response.permission.role === 1) {
          this.role = {
            type: 1,
            name: this.$lang.ui.system.l139
          }
        }
        if (response.permission.role === 2) {
          this.role = {
            type: 2,
            name: this.$lang.ui.system.l140
          }
        }
      })
      // if (this.type === 'creat') {
      //   return
      // }
      // var data = {
      //   user_id: this.creater.id,
      //   project_id: this.id
      // }
      // this.$api.getFlow(data, response => {
      //   if (response.user_quota.available_traffic < 0) {
      //     this.flow = '-' + this._global.trafficSwitch(-response.user_quota.available_traffic)
      //   } else {
      //     this.flow = this._global.trafficSwitch(response.user_quota.available_traffic)
      //   }
      // })
    },
    show (type) {
      var data = [
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceInfo',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceMembers',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceSettings',
          id: this.id
        },
        {
          role: this.role.type,
          type: 'workspace',
          spaceName: this.name,
          name: 'workspaceRecord',
          id: this.id
        }
      ]
      this.tabShow = false
      this.$store.dispatch('showOther', data[type])
    }
  }
}
</script>

<style scoped lang="css">
.space {
  position: relative;
  width: 100%;
  min-width: 220px;
  overflow: hidden;
  cursor: pointer;
  height: 55px;
  padding: 5px 18px;
}
.space.active {
  background-color: #fff;
}
.space.active .operation {
  opacity: 1;
  display: block;
}
.space:hover {
  background-color: #fff;
}
.item {
  position: absolute;
  top: 0;
  left: 45px;
}
.img {
  float: left;
  width: 45px;
  height: 45px;
  border-radius: 45px;
  overflow: hidden;
  text-align: center;
}
.img img {
  width: 45px;
  height: 45px;
}
.icon-add {
  color: #fff;
  margin-top: 10px;
}
.word {
  padding: 2px 0;
  float: left;
  height: 45px;
  width: 128px;
}
.word span{
  width: 100%;
  padding-left: 10px;
  display: inline-block;
}
.name {
  height: 23px;
  font-weight: 600;
  line-height: 23px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more {
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.operation {
  display: none;
  opacity: 0.6;
  position: absolute;
  top: 16px;
  right: 5px;
}
.operation:hover {
  opacity: 1;
}
.space:hover .operation {
  display: block;
}
.info-cell {
  padding: 6px 4px;
  cursor: pointer;
  border-radius: 2px;
}
.info-cell:hover {
  background-color: #fff;
}
.info-cell.role:hover,
.info-cell.flow:hover {
  background-color: #fff;
}
.info-cell.role {
  margin-bottom: 8px;
  border-bottom: 1px solid #ccc;
}
.info-cell.flow {
  margin-top: 8px;
  border-top: 1px solid #ccc;
}
.people {
  font-size: 20px;
}
</style>
